import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IPagedRetailerResultRequestDto, IPagedUserResultRequestDto, IRetailerDto, IUpdateRetailerDto } from 'src/app/models/backend';
import { IUserDto } from 'src/app/models/backend/users';
import { PagedListingComponentBase, PagedRequestDto } from 'src/app/shared/reusable/paged-listing-component-base';

import Swal from 'sweetalert2';
import { RetailersService } from './retailers.service';
import { CreateRetailerComponent } from './create-retailer/create-retailer.component';
import { UpdateRetailerComponent } from './update-retailer/update-retailer.component';
import { RetailerCreditsComponent } from './retailer-credits/retailer-credits.component';
import { ToastrService } from 'ngx-toastr';
import { LoginService } from '../login/login.service';
import { RetailerPlanType } from 'src/app/models/enums/retailerPlanType';
import { UpdateDiscountTemplateComponent } from './update-discount-template/update-discount-template.component';

@Component({
  selector: 'app-retailers',
  templateUrl: './retailers.component.html',
  styleUrls: ['./retailers.component.scss']
})
export class RetailersComponent extends PagedListingComponentBase<IRetailerDto>{

  loader = false;
  Retailers: any
  retailerData: IUpdateRetailerDto;
  request: IPagedRetailerResultRequestDto = {
    isInvloveDeletedItems: false,
    Keyword: "",
    maxResultCount: 10,
    skipCount: 0,
  };

  Role:any
  constructor(
    private dialog: MatDialog,
    private modalService: NgbModal,
    public retailerService: RetailersService,private toastr:ToastrService,
    public loginService:LoginService
  ) {
    super();
    this.Role=localStorage.getItem("RoleType")
  }

  protected override list(request: IPagedRetailerResultRequestDto, pageNumber: number,): void {
    this.request = {
      isInvloveDeletedItems: false,
      skipCount: 0,
      maxResultCount: 10,
      Keyword: ""
    }

    this.loader = true
    this.retailerService.GetRetailers(request).subscribe((res: any) => {
      this.Retailers= res.items.map(item=>({
        ...item,
        retailerPlanType: RetailerPlanType[item.retailerPlanType]
      }))
      console.log(this.Retailers)
      this.showPaging(res, pageNumber)
      this.loader = false
    })
  }
  protected override delete(entity: IRetailerDto): void {
    throw new Error('Method not implemented.');
  }
  openCreateModal() {
    const modalRef = this.modalService.open(CreateRetailerComponent, {
      size: 'lg', windowClass: 'mymodal', backdrop: 'static'
    });
    modalRef.closed.subscribe((o: { refresh: boolean }) => o.refresh && this.isRefresh(true));
  }
  isRefresh(refresh: boolean) { if (refresh === true) this.getDataPage(1); }

  onPageChanged(pageNumber: number) {
    this.request = {
      isInvloveDeletedItems: false,
      skipCount: (pageNumber - 1) * 10,
      maxResultCount: 10,
      Keyword: ""
    }
    console.log(pageNumber)

    this.loader = true
    this.retailerService.GetRetailers(this.request).subscribe((res: any) => {
      this.Retailers = res.items;
      console.log(this.Retailers)
      this.showPaging(res, pageNumber)
      this.getDataPage(pageNumber);
      this.loader = false
    })
    
  }
  updateDiscount(id) {
    this.retailerService.id = id
    const modalRef = this.modalService.open(UpdateDiscountTemplateComponent, {
      size: 'md', windowClass: 'mymodal', backdrop: 'static'
    });
    modalRef.closed.subscribe((o: { refresh: boolean }) => o.refresh && this.isRefresh(true));
  }

  onChangeFilter() {
    // this.getDataPage(1);
  }
  Delete(Id) {
    Swal.fire({
      title: 'Are you sure want to remove?',
      text: 'You will not be able to recover this',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
        Swal.fire(
          'Deleted!',
          'Retailer has been deleted.',
          'success'
        )
        this.retailerService.DeleteRetailer(Id).subscribe((res: any) => {
          this.getDataPage(1)
        })
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Cancelled',
          'Retailer is not deleted',
          'error'
        )
      }
    })
  }

  Edit(id) {
    this.retailerService.id = id
    const modalRef = this.modalService.open(UpdateRetailerComponent, {
      size: 'lg', windowClass: 'mymodal', backdrop: 'static'
    });
    modalRef.closed.subscribe((o: { refresh: boolean }) => o.refresh && this.isRefresh(true));
  }
  EditCredits(id) {
    this.retailerService.id = id
    const modalRef = this.modalService.open(RetailerCreditsComponent, {
      size: 'lg', windowClass: 'mymodal', backdrop: 'static'
    });
    modalRef.closed.subscribe((o: { refresh: boolean }) => o.refresh && this.isRefresh(true));
  }
  Filter(keyword) {
    this.request = {
      Keyword: keyword,
      isInvloveDeletedItems: false,
      skipCount: 0,
      maxResultCount: 10
    }
    this.retailerService.GetRetailers(this.request).subscribe((res: any) => {
      this.Retailers = res.items;
      this.showPaging(res, 1)

    })
  }
  UpdateStatusFalse(id) {
    this.loader = true
    this.retailerService.GetRetailerById(id).subscribe((res: any) => {
      console.log(res)
      res.isTestMode = false
      this.retailerData=res
      this.retailerService.UpdateRetailer(this.retailerData).subscribe((res1: any) => {
        console.log(res1)
        // Swal.fire('Updated', '', 'success')
        this.toastr.success('Updated','success')
        this.request = {
          isInvloveDeletedItems: false,
          skipCount: 0,
          maxResultCount: 10,
          Keyword: ""
        }
        this.list(this.request, 1);
        this.loader = false
      })
    })
   
  }
  async UpdateStatusTrue(id) {
    this.loader=true
    await this.retailerService.GetRetailerById(id).subscribe((res: any) => {
      console.log(res)
      res.isTestMode = true
      this.retailerData=res

      console.log(this.retailerData)
    this.retailerService.UpdateRetailer(this.retailerData).subscribe((res1: any) => {
      console.log(res1)
      // Swal.fire('Updated', '', 'success')
      this.toastr.success('Updated','Success')
      this.request = {
        isInvloveDeletedItems: false,
        skipCount: 0,
        maxResultCount: 10,
        Keyword: ""
      }
      this.list(this.request, 1);
      this.loader = false
    })
    })
    
  }
  // logout() {
  //   this.loginService.logout();
  // }
}
